// extracted by mini-css-extract-plugin
export default {"btn":"download_btn__4LiYw"};